var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.jd)?_c('CommentJd',{attrs:{"id":_vm.jd}}):(_vm.suning)?_c('CommentSuning',{attrs:{"id":_vm.suning}}):_c('CommentBase',{attrs:{"id":_vm.id,"list":_vm.goods_eval_list,"info":_vm.goods_evaluate_info}})
}
var staticRenderFns = []

export { render, staticRenderFns }